import React from 'react';
import { motion } from 'framer-motion';

// One shared, subtle fade-up used for content entering the viewport.
const Reveal = ({ children, delay = 0, as = 'div', ...props }) => {
  const Component = motion[as];
  return (
    <Component
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Reveal;
